import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

import Home from './pages/Home';
import About from './pages/About';
import Artwork from './pages/Artwork';
import Blog from './pages/Blog';
import Experiments from './pages/Experiments';
import Contact from './pages/Contact';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PostOnePage from './components/PostOnePage';
import CreatePost from './components/CreatePost';
import UserSettings from './pages/UserSettings';
import Register from './pages/Register';
import Login from './pages/Login';
import AuthChecker from './components/AuthChecker';
import Unauthorized from './pages/Unauthorized';
import StatusPage from './components/StatusPage';
import PersistLogin from './components/PersistLogin';
import DeleteAccount from './components/DeleteAccount';
import CreateComment from './components/CreateComment';

// role definition
const ROLES = {
  Role1111: 1111,
  Role7777: 7777
};

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route element={ <PersistLogin /> }>
          <Route path='/' element={ <Layout /> }>
            <Route index element={ <Home /> } />
            <Route path='about' element={ <About /> } />
            <Route path='blog' element={ <Blog /> } />
            <Route path='artwork' element={ <Artwork /> } />
            <Route path='legal-notice' element={ <LegalNotice /> } />
            <Route path='privacy-policy' element={ <PrivacyPolicy /> } />
            <Route path='experiments' element={ <Experiments /> } />
            <Route path='blog/:id' element={ <PostOnePage /> } />       
            <Route path='register' element={ <Register /> } />
            <Route path='login' element={ <Login /> } />
            <Route path='register-status' element={ <StatusPage msg='User was registered successfully!' />  } />
            <Route path='update-status' element={ <StatusPage msg='Update of the profile was successful!' /> } />
            <Route path='unauthorized' element={ <StatusPage msg='You do not have access to the requested page.' /> } />
            <Route path='deleted-status' element={ <StatusPage msg='Your profile was successfully deleted!' /> } />
            { /* protected routes */ }
            <Route element = { <AuthChecker allowedRoles={ [ROLES.Role7777] } /> } >
              <Route path='create-post' element={ <CreatePost /> } />
            </Route>
            <Route element = { <AuthChecker allowedRoles={ [ROLES.Role1111] } /> } >
              <Route path='delete-account' element={ <DeleteAccount /> } />  
            </Route>
            <Route element = { <AuthChecker allowedRoles={ [ROLES.Role7777, ROLES.Role1111] } /> } >
              <Route path='user-settings' element={ <UserSettings /> } />
              <Route path='contact' element={ <Contact /> } />
              <Route path="/create-comment/:postId" element={<CreateComment />} /> 
            </Route>
          </Route>
        </Route>
      </Routes>
      <footer>
        <blockquote className='blockquote'>
            <p className='mb-2'>History, Stephen said, is a nightmare from which I am trying to awake.</p>
            <footer className='blockquote-footer'>James Joyce</footer>
        </blockquote>
        <p className='mb-0'> Copyright @ 2024 Lukasz Molinek</p>
      </footer>
    </div>
  );
}

export default App;